import LanguagesMenu from '../../components/LanguagesMenu/LanguagesMenu';
import NotificationIcon from '../../components/NotificationIcon/NotificationIcon';
import ProfileMenu from '../../components/ProfileMenu/ProfileMenu';
import SearchBar from '../../components/SearchBar/SearchBar';
import styles from './TopBar.module.css';

function TopBar() {
  return (
    <div className={styles.TopBar}>
      <h3>Center Name</h3>
      <SearchBar />
      <LanguagesMenu />
      <NotificationIcon />
      <ProfileMenu />
    </div>
  );
}

export default TopBar;
